import React from 'react';
import styles from './categoryCardBody.module.scss';
import IconContainer from 'src/components/atomic/molecules/iconContainer/IconContainer';
import SpendingOverview from 'src/components/atomic/molecules/spendingOverview/SpendingOverview';
import SpendingBreakdown from 'src/components/atomic/molecules/spendingBreakdown/SpendingBreakdown';
import BudgetProgressBar from 'src/components/atomic/molecules/budgetProgressBar/BudgetProgressBar';
import { SpendingSumModel } from 'src/types/spending-sum.model';
import { BudgetModel } from 'src/types/budget.model';
import LiteralsService from 'src/services/literals/LiteralsService';

export interface CategoryCardBodyProps {
    spending: SpendingSumModel;
    fullTagName: string;
    handleOnClick?: () => void;
    budget?: BudgetModel;
    parentName?: string;
    isHomePage?: boolean;
    isMinWidthSmall?: boolean;
}
export default function CategoryCardBody({
    spending,
    fullTagName,
    budget,
    parentName,
    isHomePage,
    handleOnClick,
    isMinWidthSmall
}: CategoryCardBodyProps): JSX.Element {
    return (
        <div className={styles.body}>
            {isMinWidthSmall && (
                <IconContainer
                    isMinWidthSmall={isMinWidthSmall}
                    categoryName={spending.groupName}
                    parentName={parentName}
                />
            )}
            <div className={styles.content}>
                <div className={styles.spendingOverviewBreakdown}>
                    <div className={styles.spendingOverview}>
                        {!isMinWidthSmall && (
                            <IconContainer
                                isMinWidthSmall={isMinWidthSmall}
                                categoryName={spending.groupName}
                                parentName={parentName}
                            />
                        )}
                        <SpendingOverview
                            onClick={handleOnClick}
                            fullTagName={fullTagName}
                            categoryName={spending.groupName}
                            aria-label={
                                isHomePage
                                    ? LiteralsService.getLiteral('Budget.Current.viewTransactionsLinkDescription', [
                                          spending.groupName
                                      ])
                                    : LiteralsService.getLiteral('Budget.History.viewTransactionsLinkDescription', [
                                          spending.groupName
                                      ])
                            }
                            budgetAmount={budget?.monthlyAmount}
                            percentSpent={spending.percentSpent}
                            isMinWidthSmall={isMinWidthSmall}
                        />
                    </div>
                    <SpendingBreakdown
                        spent={spending.spent}
                        averageMonthlySpent={spending.average}
                        className={styles.spendingBreakdown}
                        isMinWidthSmall={isMinWidthSmall}
                    />
                </div>
                {budget && <BudgetProgressBar spentAmount={spending.spent} budgetAmount={budget.monthlyAmount} />}
            </div>
        </div>
    );
}
